import React from 'react';
import LocationManagedLocationChip from "./location/search/LocationManagedLocationChip";

const NotLiveLocationChip = () => {
  return <LocationManagedLocationChip label={"Not Live"} severity={'warning'} />
};

export default NotLiveLocationChip;